// removed by extract-text-webpack-plugin
module.exports = {"imageWrapper":"NSVHHELGVZkt2ACryvQLk","-theme-rounded-corners":"_2QiDc27rH_pyqLvoXEWu8P","image":"_3fszMFkGz0dtujlTjk25DO","-theme-full":"G3li89IXM6pl9LahigMeJ","-theme-fixed":"_11o5f7U_HxRhBUVqXv3GBH","gradient":"_30X2CUKEQq1IaUIhrDJh7r","-gradient-section":"xI9PEp8CMExZkgHb70NcL","-gradient-feature":"_28pzG7T1sUBDUA75fr51IR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FancyImage/FancyImage.module.scss
// module id = 755
// module chunks = 0